import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import { SharedStateProvider } from "../components/SharedState/PageSharedState"
import SEO from "../components/seo"
import Button from "@bit/azheng.joshua-tree.button"

const SecondChance = () => {
  const hasForm = false
  const images = []

  return (
    <SharedStateProvider>
      <Layout>
        <SEO
          lang="en"
          title="Smile Again Program at Kentuckiana Oral Maxillofacial and Dental Implant Surgery"
          description="It is time for a brand new, healthy, beautiful smile."
        />

        <div className="sc-program">
          <div className="sc__hero">
            <div className="sc__hero--desktop">
              <img
                className="sc__hero-img"
                src="/Programs/smile-again-desktop-hero-image.jpg"
                alt="program banner"
              />
            </div>
            <div className="sc__hero--mobile">
              <img
                className="sc__hero-img"
                src="/Programs/smile-again-mobile-hero-image.jpg"
                alt="program banner"
              />
            </div>
          </div>

          <div className="sc__section">
            <div className="">
              <div className="sc__about-grid--content">
                <p className="sc__subheading">
                  An Opportunity to Have a Healthy Smile Again{" "}
                </p>
                <br />
                <p>
                  Kentuckiana Oral Maxillofacial and Dental Implant Surgery is
                  proud to announce its second Smile Again program. This
                  life-changing program provides one deserving recipient with a
                  complete smile makeover free of charge.
                </p>
                <p>
                  The ideal candidate has multiple missing or failing teeth and
                  cannot afford restorative treatment. After the submission
                  period, we will select one recipient to receive a free{" "}
                  <Link
                    to="/services/full-arch-restoration/"
                    title="Learn more about full-arch restoration"
                  >
                    full-arch restoration
                  </Link>{" "}
                  procedure. We encourage anyone in our community who is
                  dreaming of a healthy, beautiful new smile to apply!
                </p>
                <br />
                <p className="sc__subheading">Full-Arch Restoration</p>
                <br />
                <p>
                  Full-arch restoration is a healthy and effective way to
                  replace missing teeth. The procedure works by securing a full
                  prosthesis in the mouth using as few as four dental implant
                  posts. The posts will permanently hold the new teeth in place
                  while also preventing bone loss.
                </p>
              </div>
              {/* <div className="sc__about-grid--info">
                <div className="sc__brackets sc__brackets--desktop">
                  <div>
                    <p className="sc__subheading">How To Apply</p>
                    <ul>
                      <li>Complete the short application.</li>
                      <li>Upload photos of your smile and teeth.</li>
                      <li>Submit your application by September 29, 2022.</li>
                    </ul>
                  </div>
                </div>
              </div> */}

              <br />
              <p className="sc__subheading">
                Thank you for your interest in the Smile Again program. The
                application period is now closed. Applicants will be notified
                once the selection process has been completed.
              </p>
            </div>
          </div>

          {hasForm && (
            <>
              <div className="sc__apply-banner">
                <p>CLICK THE BUTTON BELOW TO FILL OUT THE FORM</p>
              </div>

              <div className="sc__section sc__form">
                <a
                  className="standard-button contained"
                  href="https://secureform.seamlessdocs.com/f/974db09a5bf0f67c0e509b3e0ffa9a4b?embedded=true"
                  target="_blank"
                >
                  Submit Application
                </a>
              </div>
            </>
          )}

          <div className="sc__section">
            <p>
              Stay tuned to this page,{" "}
              <a
                href="https://www.facebook.com/LouisvilleOMFS/"
                target="_blank"
                title="Follow us on Facebook"
              >
                Facebook
              </a>
              {", "}
              and{" "}
              <a
                href="https://www.instagram.com/kentuckianaoms/"
                target="_blank"
                title="Follow us on Instagram"
              >
                Instagram
              </a>{" "}
              for program updates!
            </p>
            <p>
              <i>
                Learn more about{" "}
                <Link
                  to="/services/dental-implants-louisville-ky/"
                  title="Learn more about dental implants"
                >
                  dental implants
                </Link>{" "}
                and{" "}
                <Link
                  to="/services/full-arch-restoration/"
                  title="Learn more about full-arch restoration"
                >
                  full-arch restoration
                </Link>{" "}
                to see how they can benefit your smile. Whether you need to
                replace one tooth or an entire arch of teeth, our team has a
                solution for you.
              </i>
            </p>
          </div>
          {/* <div className="sc__section close-sfs-slider close-sc-slider">
            <ImageSlider
              images={images}
              adaptiveHeight={true}
              useArrows={true}
            />
          </div> */}
        </div>
      </Layout>
    </SharedStateProvider>
  )
}

export default SecondChance
